import React from "react";

const TableBadge = ({ label, color }) => {
  const colorMap = {
    blue: "bg-blue-50 text-blue-600 border border-blue-200",
    green: "bg-emerald-50 text-emerald-600 border border-emerald-200",
    amber: "bg-amber-50 text-amber-600 border border-amber-200",
    slate: "bg-slate-100 text-slate-600 border border-slate-200",
  };

  return (
    <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ${colorMap[color] || colorMap.slate}`}>
      {label}
    </span>
  );
};

export default TableBadge;
